import React, { useEffect, useState } from "react";
import { Button, Stack, TextField } from "@mui/material";
import axios from "axios";
import "../../styles/captionAI.scss";
import "../../styles/global.scss";

const textInputProps = {
  backgroundColor: "white",
  padding: "7.5px",
  borderRadius: "0px",
};

const CaptionHistory = (props) => {
  const [buttonActionIndex, setButtonActionIndex] = useState(null);
  const [editingTitle, setEditingTitle] = useState(null);
  const [newTitle, setNewTitle] = useState(null);
  const [showSeeMore, setShowSeeMore] = useState(false);
  const [shownItems, setShownItems] = useState(null);

  const handleSessionClick = (session) => {
    setEditingTitle(null);
    setNewTitle(null);

    axios
      .get(`/captionai/${session.id}`)
      .then((response) => {
        props.setLoadSession(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEdit = (session) => {
    setEditingTitle(session.id);
    setNewTitle(session.title);
  };

  const handleDelete = (session) => {
    axios
      .delete(`/captionai/${session.id}`)
      .then(() => {
        let newSessionHistory = props.sessionHistory;
        let newResults = newSessionHistory.results?.filter(
          (s) => s.id !== session.id
        );
        newSessionHistory.results = newResults;

        setShownItems(newSessionHistory.results);
        props.setSessionHistory(newSessionHistory);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleNewTitle = (event) => {
    setNewTitle(event.target.value);
  };

  const handleTitleUpdate = (session) => {
    let newSession = session;
    newSession.title = newTitle;

    setEditingTitle(null);
    axios.put(`/captionai/title`, newSession);
  };

  const getMoreSessions = () => {
    const nextPage = props.sessionHistory?.page + 1;

    axios
      .get(`/captionai/sessions/all?page=${nextPage}`)
      .then((response) => {
        const newHistoryObj = {
          page: response.data.page,
          pageSize: response.data.pageSize,
          results: props.sessionHistory.results.concat(response.data.results),
          totalCount: response.data.totalCount,
        };

        props.setSessionHistory(newHistoryObj);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (
      props.sessionHistory?.totalCount > props.sessionHistory?.results.length
    ) {
      setShowSeeMore(true);
    }
  }, [props.sessionHistory]);

  useEffect(() => {
    if (props.sessionHistory) {
      setShownItems(props.sessionHistory.results);
    }
  }, [props.sessionHistory])


  return (
    <div className="history-container">
      <Button
        variant="text"
        color="cc"
        sx={{ color: "white", border: "1px solid white" }}
        margin={2}
        onClick={() => props.setClearForm(true)}
        startIcon={<i className="fa fa-fw fa-plus caption-icon-spacing"></i>}
      >
        New Session
      </Button>
      {shownItems?.map((session, index) => {
        return (
          <div className="session-item">
            {editingTitle === session.id ? (
              <div className="history-button-row">
                <TextField
                  className="new-title-input"
                  variant="filled"
                  onChange={handleNewTitle}
                  value={newTitle}
                  inputProps={{ style: textInputProps }}
                />
                <i
                  className="fa fa-fw fa-check clickable"
                  onClick={() => handleTitleUpdate(session)}
                ></i>
              </div>
            ) : (
              <div
                onMouseEnter={() => setButtonActionIndex(index)}
                onMouseLeave={() => setButtonActionIndex(null)}
                className="session-row"
              >
                {buttonActionIndex === index ? (
                  <div className="history-button-row spaced">
                    <button
                      className="load-history-button"
                      onClick={() => handleSessionClick(session)}
                    >
                      {session.title}
                    </button>
                    <>
                      <div className="history-actions">
                        <i
                          className="fa fa-fw fa-pencil clickable"
                          onClick={() => handleEdit(session)}
                        ></i>
                        <i
                          className="fa fa-fw fa-trash clickable"
                          onClick={() => handleDelete(session)}
                        ></i>
                      </div>
                    </>
                  </div>
                ) : (
                  <button
                    className="session-button"
                    onClick={() => handleSessionClick(session)}
                  >
                    {session.title}
                  </button>
                )}
              </div>
            )}
          </div>
        );
      })}
      {showSeeMore ? (
        <Button
          variant="text"
          color="cc"
          sx={{ color: "white", border: "1px solid white" }}
          margin={2}
          onClick={getMoreSessions}
          className="see-more-button"
        >
          See More
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CaptionHistory;
